<template>
	<div id="resumoAlertas">
		<a-row type="flex" justify="space-between" align="bottom">
			<a-col :span="4">
				<a-row>
					<span>Tribunal:</span>
				</a-row>
				<a-row>
					<a-select
						style="width: 95%;"
						v-model="filter.tribunal"
						allowClear
						show-search
						placeholder="Selecione ou digite"
						option-filter-prop="children"
						:filter-option="filtrarTribunal"
						:disabled="loading"
						@change="onChangeTribunal"
					>
						<a-select-option
							v-for="tribunal in listaTribunais"
							:key="tribunal.tribunal"
							:value="tribunal.tribunal"
						>
							{{ tribunal.tribunal }}
						</a-select-option>
					</a-select>
				</a-row>
			</a-col>
			<a-col :span="4">
				<a-row>
					<span>Fornecedor:</span>
				</a-row>
				<a-row>
					<a-input
						style="width: 95%;"
						placeholder="Fornecedor"
						v-model="filter.fornecedor"
						:disabled="loading"
						@change="onChangeFornecedor"
					/>
				</a-row>
			</a-col>
			<a-col :span="3">
				<a-row>
					<span>Tipo Credencial:</span>
				</a-row>
				<a-select
					style="width: 95%;"
					@change="onChangeTipoCredencial"
					:value="valueTipoCredencial"
					:disabled="loading"
					:allowClear="valueTipoCredencial!='4'"
					>
					<a-select-option value="4">Todos</a-select-option>
					<a-select-option value="1">Dado</a-select-option>
					<a-select-option value="2">Autos</a-select-option>
					<a-select-option value="3">Autos/Dado</a-select-option>
				</a-select>
			</a-col>

			<a-col :span="3">
				<a-row>
					<span class="tr-label">Inicial:</span>
				</a-row>
				<a-row>
					<a-date-picker
						@change="onChangeDataIncialErro"
						placeholder="Data Incial"
						style="width: 95%;"
						:format="dateFormat"
						:disabled="loading"
					/>
				</a-row>
			</a-col>
			<a-col :span="3">
				<a-row>
					<span class="tr-label">Final:</span>
				</a-row>
				<a-row>
					<a-date-picker
						@change="onChangeDataFinalErro"
						placeholder="Data Final"
						style="width: 95%;"
						:format="dateFormat"
						:disabled="loading"
					/>
				</a-row>
			</a-col>
			
			<a-col :span="3" :offset="4" style="text-align: right;">
				<a-button
					class="tr-search-btn"
					type="primary"
					@click.stop.prevent="carregarResumoAlertas()"
					:disabled="loading"
				>Pesquisar</a-button>
			</a-col>
		</a-row>

		<a-row style="height: calc(100vh - 230px); overflow-y: auto; overflow-x: auto; min-height: 100px;">
			<a-table
				:columns="columnsTribunal"
				:rowKey="record => record.key"
				:dataSource="data"
				:loading="{ spinning: loading, tip: 'Carregando...' }"
				:pagination="pagination"
				:expandedRowKeys="expandedTribunalKeys"
				@expandedRowsChange="onTribunalExpandedRowsChange"
				@change="handleTableChange"
				size="middle"
				class="resumo-alertas-table nivel-tribunal"
			>
				<template slot="expandedRowRender" slot-scope="tribunalRecord">
					<a-table
						:columns="columnsFornecedor"
						:rowKey="record => record.key"
						:dataSource="tribunalRecord.fornecedores"
						:pagination="false"
						:showHeader="true"
						:expandedRowKeys="getFornecedorExpandedKeys(tribunalRecord.key)"
						@expandedRowsChange="keys => onFornecedorExpandedRowsChange(tribunalRecord.key, keys)"
						size="middle"
						class="nested-table nivel-fornecedor"
					>
						<template slot="expandedRowRender" slot-scope="fornecedorRecord">
							<a-table
								:columns="columnsDetalhe"
								:rowKey="item => item.key"
								:dataSource="fornecedorRecord.alertas"
								:pagination="false"
								size="small"
								class="nested-table-detalhe"
							>
								<template
									slot="tipoCredencial"
									slot-scope="tipoCredencial, item"
								>{{ formatarTipoCredencial(item.tipoCredencial) }}
								</template>
								<template
									slot="dataCadastro"
									slot-scope="dataCadastro, item"
								>{{ formatarDataLocal(item.dataCadastro, true, 'DD/MM/YYYY HH:mm:ss') }}
								</template>
							</a-table>
						</template>
					</a-table>
				</template>
			</a-table>
			<a-row type="flex" align="bottom">
				<a-button
					class="btnExcel"
					type="primary"
					icon="file-excel"
					size="default"
					@click.stop.prevent="exportarExcel"
				/>
			</a-row>
		</a-row>
	</div>
</template>

<script>
import PortalCredencialWebApi from "@/API/PortalCredencialWebApi";
import moment from "moment";
import { showNotificationError } from "@/util/showNotification";
import { showNotificationSucess } from "@/util/showNotification";
import Helpers from "@/util/Helpers";


const columnsTribunal = [
	{
		title: "Tribunal",
		dataIndex: "tribunal",
		sorter: (a, b) => a.tribunal.localeCompare(b.tribunal),
	},
];
const columnsFornecedor = [
	{
		title: "Fornecedor",
		dataIndex: "fornecedor",
		sorter: (a, b) => a.fornecedor.localeCompare(b.fornecedor),
	},
	{

		title: "Qtd. Alertas",
		dataIndex: "qtdAlertas",
		width: "15%",
		align: "center",
		sorter: (a, b) => a.qtdAlertas - b.qtdAlertas,
	},
];
const columnsDetalhe = [
	{
		title: "NPU",
		dataIndex: "processo",
		width: "22%",
		sorter: (a, b) => (a.processo || "").localeCompare(b.processo || ""),
	},
	{
		title: "Tipo Credencial",
		dataIndex: "tipoCredencial",
		sorter: (a, b) => a.tipoCredencial.localeCompare(b.tipoCredencial),
		scopedSlots: { customRender: "tipoCredencial" }
	},
	{
		title: "Data",
		dataIndex: "dataCadastro",
		width: "18%",
		scopedSlots: { customRender: "dataCadastro" },
		sorter: (a, b) => (a.dataCadastro || "").localeCompare(b.dataCadastro || ""),

	},
	{
		title: "Erro",
		dataIndex: "mensagemErro",
		sorter: (a, b) => (a.mensagemErro || "").localeCompare(b.mensagemErro || ""),
	},

];

export default {
	name: "resumoAlertas",
	data() {
		return {
			idTela: 5,
			listaTribunais: [],
			data: [],
			pagination: {},
			loading: false,
			dateFormat: "DD/MM/YYYY",
			columnsTribunal,
			columnsFornecedor,
			columnsDetalhe,
			filter: {
				tribunal: null,
				fornecedor: null,
				dataInicialErro: '',
				dataFinalErro: '',
				tipoCredencial: "4",
				idUsuario: null,
				idPerfil: null,
			},
			valueTipoCredencial: "4",
			valueDataInicialErro: null,
			valueDataFinalErro: null,
			selectedRowKeys: [],
			expandedTribunalKeys: [],
			expandedFornecedorKeys: {},
		};
	},
	mounted() {
		// this.carregarResumoAlertas();
		this.carregarTribunais();
	},
	methods: {
		agruparAlertas(alertas) {
			const tribunais = {};
			alertas.forEach((item, index) => {
				const tribunal = item.tribunal || "";
				const fornecedor = item.fornecedor || "";
				const tKey = tribunal;
				const fKey = `${tribunal}|${fornecedor}`;
				if (!tribunais[tKey]) {
					tribunais[tKey] = {
						key: tKey,
						tribunal,
						fornecedores: {},
					};
				}
				if (!tribunais[tKey].fornecedores[fKey]) {
					tribunais[tKey].fornecedores[fKey] = {
						key: fKey,
						fornecedor,
						qtdAlertas: 0,
						alertas: [],
					};
				}
				tribunais[tKey].fornecedores[fKey].qtdAlertas += 1;
				tribunais[tKey].fornecedores[fKey].alertas.push({
					...item,
					key: `${fKey}-${index}`,
				});
			});
			return Object.values(tribunais).map(tribunal => ({
				...tribunal,
				fornecedores: Object.values(tribunal.fornecedores),
			}));
		},

		carregarResumoAlertas() {
			if (!this.validarFiltro()) {
				return;
			}
			this.filter.idUsuario = this.$store.state.auth.idUser;
			this.filter.idPerfil = this.$store.state.auth.idPerfilPortal;
			this.loading = true;
			PortalCredencialWebApi.getResumoAlertas(this.prepararFiltroParaEnvio()).then(res => {
				this.loading = false;
				if (res.data.statusCode != 200) {
					showNotificationError(this, "Relatório de Alertas", res.data.errorMessage);
					return;
				}
				if (typeof res.data.result == "string") {
					showNotificationSucess(this, "Relatório de Alertas", res.data.result);
				} else {
					this.data = this.agruparAlertas(res.data.result);
					this.pagination = { current: 1 };
					this.expandedTribunalKeys = [];
					this.expandedFornecedorKeys = {};
				}
			}).catch(() => {
				this.loading = false;
				showNotificationError(this, "Relatório de Alertas", "Erro ao tentar carregar lista de fonte monitoradas.");
			});
		},
		async exportarExcel() {
			PortalCredencialWebApi.exportarRelatorioAlertas(this.prepararFiltroParaEnvio())
				.then(res => {
					this.loading = false;
					const arrayValidacao = [null, "undefined", ""];
					const data = res.data;
					if (!arrayValidacao.includes(data)) {
						const blob = new Blob([res.data], {
							type: "application/vnd.ms-excel",

						});
						const link = document.createElement("a");
						link.href = window.URL.createObjectURL(blob);
						link.download = `Relatório_Resumo_Alertas${new Date().toLocaleDateString()}.xlsx`;
						document.body.appendChild(link);
						link.click();
						document.body.removeChild(link);
					} else {
						showNotificationError(this, "Relatório de Alertas", "Erro ao tentar gerar arquivo.");
					}
				})
				.catch(() => {
					this.loading = false;
					showNotificationError(this, "Relatório de Alertas", "Erro ao tentar gerar arquivo.");
				});
		},
		handleTableChange(pagination) {
			const pager = { ...this.pagination };
			pager.current = pagination.current;
			this.pagination = pager;

		},

		onTribunalExpandedRowsChange(expandedRowKeys) {

			const collapsedKeys = this.expandedTribunalKeys.filter(

				key => !expandedRowKeys.includes(key),

			);

			collapsedKeys.forEach(key => {

				this.$delete(this.expandedFornecedorKeys, key);

			});

			this.expandedTribunalKeys = expandedRowKeys;

		},

		getFornecedorExpandedKeys(tribunalKey) {

			return this.expandedFornecedorKeys[tribunalKey] || [];

		},

		onFornecedorExpandedRowsChange(tribunalKey, expandedRowKeys) {

			this.$set(this.expandedFornecedorKeys, tribunalKey, expandedRowKeys);

		},
		onChangeFornecedor() {
			this.filter.fornecedor = this.filter.fornecedor === "" || this.filter.fornecedor === undefined ? null : this.filter.fornecedor;
		},
		onChangeTribunal(value) {
			this.filter.tribunal = value == "" || value == undefined ? null : value;
		},
		onChangeTipoCredencial(value) {
			this.valueTipoCredencial = value == undefined ? "4" : value;
			this.filter.tipoCredencial = this.valueTipoCredencial == "4" ? null : this.valueTipoCredencial;
		},
		onChangeDataIncialErro(date) {
			this.valueDataInicialErro = date;
    		this.filter.dataInicialErro = date; 
		},
		onChangeDataFinalErro(date) {
			this.valueDataFinalErro = date;
    		this.filter.dataFinalErro = date; 
		},

		formatarDataParaEnvio(valor) {
			if (!valor) {

				return null;

			}
			if (moment.isMoment(valor)) {

				return valor.format("YYYY-MM-DD");

			}
			if (typeof valor === "string" && valor.includes("T")) {

				return moment(valor).format("YYYY-MM-DD");

			}

			return valor;

		},

		prepararFiltroParaEnvio() {
			return {
				...this.filter,
				dataInicialErro: this.formatarDataParaEnvio(this.filter.dataInicialErro),
				dataFinalErro: this.formatarDataParaEnvio(this.filter.dataFinalErro),
			};

		},
		formatarDataLocal(data, isDateTime, format) {
			return Helpers.formatarData(data, isDateTime, format);
		},
		formatarTipoCredencial(value) {
			return Helpers.formatarTipo(value);
		},
		validarFiltro() {
			const diff = moment(this.filter.dataFinalErro, "YYYY-MM-DD").diff(moment(this.filter.dataInicialErro, "YYYY-MM-DD"));

			if (moment.duration(diff)._data.days < 0)
			{
				showNotificationError(this, "Relatório de Alertas", "Data Final não pode ser menor do que a Data Inicial.");
				return false;
			}
			if (moment.duration(diff)._data.months >= 1 || moment.duration(diff)._data.years >= 1)
			{
				showNotificationError(this, "Relatório de Alertas", "Período não pode ser maior do que 30 dias.");
				return false;
			}
			if (this.valueDataInicialErro == null || this.valueDataFinalErro == null){
				showNotificationError(this, "Relatório de Alertas", "Data Inicial e Final é um campo Obrigatório!");
				return false;
			}

			return true;
		},

		carregarTribunais() {
			PortalCredencialWebApi.getTribunais()
				.then(res => {
					if (res.data.statusCode !== 200) {
						showNotificationError(this, "Tribunal", res.data.errorMessage);
						return;
					}

					this.listaTribunais = res.data.result;
				})
				.catch(() => {
					showNotificationError(this, "Tribunal", "Erro ao carregar tribunais.");
				});
		},

		filtrarTribunal(input, option) {
			return option.componentOptions.children[0].text
				.toLowerCase()
				.includes(input.toLowerCase());
		},
	},
};

</script>

<style scoped>
span {
	color: #000;
	font-family: "Segoe UI", "Segoe UI Emoji", "Segoe UI Symbol", "Courier New",
		Courier, monospace;
	font-weight: bold;
}

div .ant-row-flex {
	margin-top: 5px;
	margin-bottom: 10px;
}

.content {
	height: 100%;
}

.ant-layout {
	height: 100%;
	background: "#fff";
}

.ant-layout-content {
	height: 100%;
	background: #fff;
}

.ant-layout-footer {
	position: absolute;
	bottom: 0;
	width: 100%;
}
.cursor {
	cursor: pointer;
}

.cursor:hover {
	color: blue;
}

.danger {
	color: red;
}

.sucess {
	color: green;
}

.config-form-button {
	width: 100px;
}

.tr-ant-select {
	margin: 10px 0px 10px 0px;
}
.btnExcel {
	text-align: "center";
	position: "relative";

	width: 45px;
	height: 45px;
	font-size: 24px;
	font-weight: bold;
	cursor: pointer;
	border-radius: 50%;
}
.btnExcel:hover {
	background-color: #0755A4;
	transition: all 0.3s ease-in;
}
</style>

<style>

#resumoAlertas .resumo-alertas-table .ant-table-expanded-row > td {

	padding: 0;

	background: #fff;

	border-bottom: none;

}

#resumoAlertas .nested-table {
	margin: 0;
}

#resumoAlertas .nivel-fornecedor {
	padding-left: 16px;
}

#resumoAlertas .nested-table-detalhe {
	padding-left: 16px;
	margin-top: 0;
	margin-bottom: 8px;
}

#resumoAlertas .nivel-fornecedor .ant-table-expanded-row > td {
	padding: 0;
	background: #fff;
	border-bottom: none;

}

#resumoAlertas .nested-table-detalhe .ant-table-thead > tr > th,
#resumoAlertas .nivel-tribunal > .ant-table-content > .ant-table-body > table > .ant-table-thead > tr > th,
#resumoAlertas .nivel-fornecedor .ant-table-thead > tr > th {

	background: #b8c2cc;
	color: #000;
	font-weight: 600;
	border-bottom: 1px solid #a0aab4;
}

#resumoAlertas .nivel-tribunal > .ant-table-content > .ant-table-body > table > .ant-table-thead > tr > th {
	font-size: 16px;
}

#resumoAlertas .nested-table .ant-table-tbody > tr > td,
#resumoAlertas .nivel-tribunal .ant-table-tbody > tr > td {
	background: #fff;
}

#resumoAlertas .nivel-tribunal .ant-table-tbody > tr > td {
	font-size: 16px;
}

#resumoAlertas .ant-table-row-expand-icon {
	width: 24px;
	height: 24px;
	line-height: 24px;
	font-size: 16px;
}

#resumoAlertas .nested-table-detalhe .ant-table {
	background: #fafafa;
}

#resumoAlertas .nested-table-detalhe .ant-table-tbody > tr > td {
	background: #fff;
}

#resumoAlertas .nested-table-detalhe .ant-table-tbody > tr:hover > td {
	background: #f5f5f5;
}
</style>